import styled from 'styled-components';
import { colorWhite, mediaMd, mediaSm, mediaXs } from 'theme/theme-helper-selectors';

export const ConferenceContainer = styled.div`
    cursor: pointer;
    overflow: hidden;
    background: linear-gradient(180deg, #1d1d1b 0%, #1d1d1b 100%);
    border-radius: 32px;
    margin: 0px;
    padding: 0px;
    border: 1px solid;
    min-width: calc(25% - 24px);
    max-width: calc(25% - 24px);
    border-image-source: linear-gradient(180deg, #5a5a5a 0%, rgba(102, 102, 102, 0) 100%);
    @media (${mediaMd}) {
        border-radius: 24px;
        max-width: 311px;
        min-width: 311px;
    }
    @media (${mediaSm}) {
        border-radius: 16px;
        max-width: 311px;
        min-width: 311px;
    }
    @media (${mediaXs}) {
        border-radius: 16px;
        max-width: 311px;
        min-width: 311px;
    }
    display: flex;
    flex-direction: column;
`;

export const ImageContent = styled.div<{ image?: string }>`
    background-image: url(${({ image }) => image});
    border-radius: 0px 0px 16px 16px;
    width: 428px;
    height: 240px;
    background-position: center;
    background-repeat: no-repeat;
    background-size: cover;
    @media (${mediaMd}) {
        width: 309px;
        height: 173px;
    }
    @media (${mediaSm}) {
        width: 309px;
        height: 173px;
    }
    @media (${mediaXs}) {
        width: 309px;
        height: 173px;
    }
`;

export const DescriptionContent = styled.div`
    display: flex;
    flex-direction: row;
    padding: 24px 48px;
    @media (${mediaMd}) {
        padding: 24px 32px;
    }
    @media (${mediaSm}) {
        padding: 24px 32px;
    }
    @media (${mediaXs}) {
        padding: 24px 24px;
    }
`;

export const DescriptionText = styled.div`
    display: flex;
    flex: 1;
    flex-direction: column;
`;

export const ContentContainer = styled.div`
    display: flex;
    flex-direction: row;
`;

export const Title = styled.p`
    font-weight: 500;
    font-size: 32px;
    padding-bottom: 8px;
    color: ${colorWhite};
    @media (${mediaXs}) {
        font-size: 24px;
    }
`;

export const Description = styled.p`
    font-weight: 400;
    font-size: 18px;
    color: #ffffff99;
    @media (${mediaXs}) {
        font-size: 16px;
    }
`;

export const ArrowLink = styled.div`
    padding-top: 3px;
    padding-left: 20px;
`;
